import classNames from 'classnames'
import React from 'react'
import './index.less'

export interface ProCardActionsProps {
  /**
   * 自定义前缀
   *
   * @ignore
   */
  prefixCls?: string
  /** 操作按钮 */
  actions?: React.ReactNode[] | React.ReactNode
}

const ProCardActions: React.FC<ProCardActionsProps> = (props) => {
  const { actions, prefixCls } = props

  if (Array.isArray(actions) && actions?.length) {
    return (
      <ul className={classNames(`${prefixCls}-actions`)}>
        {actions.map((action, index) => (
          <li
            style={{ width: `${100 / actions.length}%`, padding: 0, margin: 0 }}
            key={`action-${index}`}
            className={classNames(`${prefixCls}-actions-item`)}
          >
            {action}
          </li>
        ))}
      </ul>
    )
  }
  return <ul className={classNames(`${prefixCls}-actions`)}>{actions}</ul>
}

export default ProCardActions
